import type { Email } from "@stockline/shared/types/communications/email"
import type { OfflineResourceConfig } from "../../../types"
import { EMAIL_TABLE } from "./db"

export const emailConfig: OfflineResourceConfig<Email> = {
  name: "emails",
  // Server visibility is GROUP-scoped: wiped + cold re-pulled on a
  // scope change (STK-1238).
  groupScoped: true,
  // STK-1325: the list syncs metadata-only (light) at readiness; the heavy body
  // (~10KB/row) hydrates via a resumable background backfill (GET ?body=true),
  // with GET /emails/:id as the open-before-backfill fallback.
  backfillBody: true,
  bodyBackfillPageSize: 50,
  // Cold-start list page size. Metadata-only now (the body backfills
  // separately @50), so the page is light and the old 200 guard became
  // counter-productive: 1000/page divides the background-sync request count
  // ~5x (vivo 840 → 168), cutting server load. Doesn't affect the boot screen —
  // emails stream in behind a usable recap. STK-1929.
  pageSize: 1000,
  endpoints: {
    full: "/api/v2/emails",
    // No push endpoint — read-only resource. SyncEngine still expects the
    // field, so point it at the (non-existent) changes URL; client mutations
    // are never enqueued for read-only resources.
    delta: "/api/v2/emails/changes",
    push: "/api/v2/emails/changes",
  },
  tableName: EMAIL_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
    emailAccountId: "emailAccountId",
    archived: "archived",
    read: "read",
    emailDate: "emailDate",
    syncId: "syncId",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
